import { AuditValueStatus } from '../../types'

export const statusFromValuesMatch = (
    rentRollValue: string | null,
    documentValue: string | null,
    valuesMatch: boolean | null | undefined,
): AuditValueStatus => {
    if (rentRollValue && !documentValue) {
        return 'MISSING_DOCUMENT'
    }

    if (!rentRollValue && documentValue) {
        return 'MISSING_RENT_ROLL'
    }

    if (!rentRollValue && !documentValue) {
        return 'MATCHED'
    }

    return valuesMatch ? 'MATCHED' : 'NOT_MATCHED'
}
